// extracted by mini-css-extract-plugin
module.exports = {"activationAlert":"ActivationAlert_activationAlert__1u4zX","activationAlert__icon":"ActivationAlert_activationAlert__icon__3075z"};